import React from 'react';

function FooterSettings({ settings, setSettings, uploading, uploadingField, handleSettingsImageUpload, handleSettingsImageDelete }) {
  return (
    <div className="editor-section">
      <h3>🦶 Footer Settings</h3>
      
      <div className="form-group">
        <label>Footer Logo</label>
        {settings.footerLogo && <img src={settings.footerLogo} className="preview-img" />}
        <div style={{display:'flex', gap:10}}>
          <label className="upload-label">
            {uploading && uploadingField === 'footerLogo' ? '⏳...' : '📷 Upload Logo'}
            <input type="file" accept="image/*" style={{display:'none'}} onChange={(e) => { if (e.target.files[0]) handleSettingsImageUpload('footerLogo', e.target.files[0]); }} />
          </label>
          {settings.footerLogo && <button className="remove-btn" onClick={() => handleSettingsImageDelete('footerLogo', settings.footerLogo)}>🗑️ Delete</button>}
        </div>
        <small>Recommended size: 150x60px. Logo will appear in footer.</small>
      </div>
      
      <div className="form-group">
        <label>Footer BG Color</label>
        <input type="color" value={settings.footerBgColor || '#0f2244'} onChange={(e) => setSettings({...settings, footerBgColor: e.target.value})} className="form-input" style={{height:'40px'}} />
      </div>
      
      <div className="form-group">
        <label>Footer Text Color</label>
        <input type="color" value={settings.footerTextColor || '#ffffff'} onChange={(e) => setSettings({...settings, footerTextColor: e.target.value})} className="form-input" style={{height:'40px'}} />
      </div>
      
      <div className="form-group">
        <label>About Text</label>
        <textarea value={settings.aboutText || 'Providing quality education and nurturing future leaders since 1995.'} onChange={(e) => setSettings({...settings, aboutText: e.target.value})} rows="3" className="form-input" />
      </div>
      
      <div className="form-group">
        <label>Address</label>
        <textarea value={settings.address || ''} onChange={(e) => setSettings({...settings, address: e.target.value})} rows="3" className="form-input" />
      </div>
      
      <div className="form-row">
        <div className="form-group">
          <label>Phone</label>
          <input type="text" value={settings.phone || ''} onChange={(e) => setSettings({...settings, phone: e.target.value})} className="form-input" />
        </div>
        <div className="form-group">
          <label>Email</label>
          <input type="email" value={settings.email || ''} onChange={(e) => setSettings({...settings, email: e.target.value})} className="form-input" />
        </div>
      </div>
      
      <div className="form-group">
        <label>Google Maps Embed URL or Code</label>
        <textarea value={settings.googleMapEmbedUrl || ''} onChange={(e) => setSettings({...settings, googleMapEmbedUrl: e.target.value})} rows="4" className="form-input" placeholder="Paste Google Maps embed code or URL..." />
        <small>Get embed code from Google Maps → Share → Embed a map</small>
      </div>
      
      <div className="form-group">
        <label>Social Media Links</label>
        <div className="social-links-editor">
          <input placeholder="Facebook URL" value={settings.facebook || ''} onChange={(e) => setSettings({...settings, facebook: e.target.value})} className="form-input" />
          <input placeholder="Instagram URL" value={settings.instagram || ''} onChange={(e) => setSettings({...settings, instagram: e.target.value})} className="form-input" />
          <input placeholder="YouTube URL" value={settings.youtube || ''} onChange={(e) => setSettings({...settings, youtube: e.target.value})} className="form-input" />
          <input placeholder="Twitter URL" value={settings.twitter || ''} onChange={(e) => setSettings({...settings, twitter: e.target.value})} className="form-input" />
          <input placeholder="LinkedIn URL" value={settings.linkedin || ''} onChange={(e) => setSettings({...settings, linkedin: e.target.value})} className="form-input" />
        </div>
      </div>
      
      <div className="form-group">
        <label>Copyright Text</label>
        <input type="text" value={settings.copyright || `© 2026 ${settings.schoolName || 'School'}. All Rights Reserved.`} onChange={(e) => setSettings({...settings, copyright: e.target.value})} className="form-input" />
      </div>
      
      <div className="form-group">
        <label>Footer Preview</label>
        <div style={{background: settings.footerBgColor || '#0f2244', color: settings.footerTextColor || '#ffffff', padding: 20, borderRadius: 12}}>
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10}}>
            <div>
              <strong>{settings.schoolName || 'School Name'}</strong>
            </div>
            <div style={{display: 'flex', gap: 15}}>
              {settings.facebook && <span>📘</span>}
              {settings.instagram && <span>📷</span>}
              {settings.youtube && <span>▶</span>}
            </div>
          </div>
          <div style={{marginTop: 15, fontSize: 12, borderTop: '1px solid rgba(255,255,255,0.2)', paddingTop: 15, textAlign: 'center'}}>
            {settings.copyright || '© 2026 School. All Rights Reserved.'}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FooterSettings;